// extracted by mini-css-extract-plugin
export default {"discountTag":"discountTag__kfFsf","mobile":"mobile__lj2Z1","planCard":"planCard__6h8im","cardShadow":"cardShadow__xWRuM"};